var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('working-group-add',{attrs:{"isEdit":true},on:{"showSubsections":_vm.showSubsections}}),_c('working-group-subsections',{ref:"subsectionComponent"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }